import { idlFactory as icrc1Factory } from '../../idls/tokens/icrc1.did'
import type { _SERVICE as ICRC1Actor } from '../../idls/tokens/icrc1.did'

import { idlFactory as dip20Factory } from '../../idls/tokens/dip20.did'
import type { _SERVICE as DIP20Actor } from '../../idls/tokens/dip20.did'

import { idlFactory as drc20Factory } from '../../idls/tokens/drc20.did'
import type { _SERVICE as DRC20Actor } from '../../idls/tokens/drc20.did'

import { idlFactory as icpFactory } from '../../idls/tokens/icp.did'
import type { _SERVICE as ICPActor } from '../../idls/tokens/icp.did'

import { idlFactory as icrc2Factory } from '../../idls/tokens/icrc2.did'
import type { _SERVICE as ICRC2Actor } from '../../idls/tokens/icrc2.did'

import { idlFactory as icrc3Factory } from '../../idls/tokens/icrc3.did'
import type { _SERVICE as ICRC3Actor } from '../../idls/tokens/icrc3.did'

import { idlFactory as xtcFactory } from '../../idls/tokens/xtc.did'
import type { _SERVICE as XTCActor } from '../../idls/tokens/xtc.did'

import { Actor, ActorSubclass, HttpAgent } from '@dfinity/agent'

interface TokenActor {
  icp?: ActorSubclass<ICPActor>
  icrc1?: ActorSubclass<ICRC1Actor>
  icrc2?: ActorSubclass<ICRC2Actor>
  icrc3?: ActorSubclass<ICRC3Actor>
  dip20?: ActorSubclass<DIP20Actor>
  drc20?: ActorSubclass<DRC20Actor>
  xtc?: ActorSubclass<XTCActor>
}

const getIcrc1Actor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(icrc1Factory, {
    canisterId,
    agent,
  }) as ActorSubclass<ICRC1Actor>
}

const getIcrc2Actor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(icrc2Factory, {
    canisterId,
    agent,
  }) as ActorSubclass<ICRC2Actor>
}

const getIcrc3Actor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(icrc3Factory, {
    canisterId,
    agent,
  }) as ActorSubclass<ICRC3Actor>
}

const getDip20Actor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(dip20Factory, {
    canisterId,
    agent,
  }) as ActorSubclass<DIP20Actor>
}

const getDrc20Actor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(drc20Factory, {
    canisterId,
    agent,
  }) as ActorSubclass<DRC20Actor>
}

const getIcpActor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(icpFactory, {
    canisterId,
    agent,
  }) as ActorSubclass<ICPActor>
}

const getXTCActor = (canisterId: string, agent: HttpAgent) => {
  return Actor.createActor(xtcFactory, {
    canisterId,
    agent,
  }) as ActorSubclass<XTCActor>
}

const getTokenActor = (canisterId: string, standard: string, agent: HttpAgent): TokenActor => {
  switch (standard) {
    case 'ICP':
      return { icp: getIcpActor(canisterId, agent) }
    case 'ICRC1':
      return { icrc1: getIcrc1Actor(canisterId, agent) }
    case 'ICRC2':
      return { icrc2: getIcrc2Actor(canisterId, agent) }
    case 'ICRC3':
      return { icrc3: getIcrc3Actor(canisterId, agent) }
    case 'DIP20':
      return { dip20: getDip20Actor(canisterId, agent) }
    case 'DRC20':
      return { drc20: getDrc20Actor(canisterId, agent) }
    case 'XTC':
    case 'DIP20-XTC':
      return { xtc: getXTCActor(canisterId, agent) }
    default:
      return {}
  }
}

export default getTokenActor
